import React from 'react';
import { brandsEngagements } from '../data/mock';

const ClientsSection = () => {
  return (
    <section id="clients" className="bg-[#121212] py-24 md:py-32 px-[7.6923%]">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-semibold text-white mb-4 tracking-tight">
            Trusted by Leading Brands
          </h2>
          <div className="w-20 h-1 bg-[#00FFD1] mx-auto mb-6"></div>
          <p className="text-lg text-white/85 max-w-[700px] mx-auto">
            We partner with forward-thinking organizations across industries to drive digital excellence
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {brandsEngagements.map((brand) => (
            <div
              key={brand.id}
              className="bg-black p-6 border border-white/25 transition-all duration-400 hover:border-[#00FFD1] hover:shadow-[0_0_20px_rgba(0,255,209,0.2)] hover:-translate-y-1 group"
            >
              {/* Logo Container */}
              <div className="w-full h-40 mb-6 bg-white/5 flex items-center justify-center overflow-hidden">
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className="w-full h-full object-cover transition-transform duration-400 group-hover:scale-105"
                />
              </div>

              {/* Brand Name */}
              <h3 className="text-xl font-semibold text-white mb-3">
                {brand.name}
              </h3>

              {/* Engagement Description */}
              <p className="text-sm text-white/85 leading-relaxed">
                {brand.engagement}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
